export interface User {
    id?: string;
    identifier: string;
    identifierType: string;
    email: string;
    phoneNumber: string;
    displayName: string;
    site: string;
    relatedStudents?: Student[];
    createdAt: string;
    // Address fields
    address?: string;
    city?: string;
    // Student-specific fields
    firstName?: string;
    lastName?: string;
    orgUnit?: string;
    role?: string;
    phone?: string;
    photoURL?: string;
    suspended?: boolean;
    updatedAt?: string;
}

export enum UserRole {
  ADMIN = 'admin',
  DIRECTIVE = 'dir',
  SUPERADMIN = 'superadmin',
  EDUCATOR = 'educator',
  STUDENT = 'student',
  ATTENDANT = 'attendant',
}

export interface Student {
  id: string;
  name: string;
  documentId: string;
  firstName?: string;
  lastName?: string;
  orgUnit?: string;
  phone?: string;
  photoURL?: string;
  suspended?: boolean;
  updatedAt?: string;
}
